import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { MaskLines, Reveal } from "./Reveal";

export const PageHeader = ({ eyebrow, lines, intro, children }) => (
  <section className="wrap pb-14 pt-16 sm:pb-20 sm:pt-24 lg:pt-28">
    <Reveal><span className="eyebrow">{eyebrow}</span></Reveal>
    <MaskLines lines={lines} delay={0.1} className="mt-6 max-w-5xl font-display text-[2.6rem] font-bold leading-[0.98] tracking-tight sm:text-6xl lg:text-7xl" testId="page-title" />
    {intro && <Reveal delay={0.35}><p className="lede mt-8 max-w-2xl">{intro}</p></Reveal>}
    {children}
  </section>
);

export const CtaBand = ({ title = ["Let's get", "things moving."], text = "Thirty minutes, one call, no slide deck. Tell us where you want to go and we'll share a few ideas you can use tomorrow, whether you hire us or not." }) => (
  <section className="wrap pb-20 sm:pb-28">
    <div className="grain relative overflow-hidden rounded-[2rem] bg-navy px-6 py-16 text-white sm:px-14 sm:py-24" data-testid="cta-band">
      <div className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full bg-flame/90 blur-[2px]" aria-hidden="true" />
      <div className="pointer-events-none absolute -right-10 -top-10 h-44 w-44 rounded-full border-[18px] border-white/10" aria-hidden="true" />
      <div className="relative grid items-end gap-10 lg:grid-cols-12">
        <div className="lg:col-span-8">
          <MaskLines as="h2" onLoad={false} lines={title} className="font-display text-4xl font-bold leading-[1] tracking-tight sm:text-6xl lg:text-7xl" />
          <p className="mt-6 max-w-xl text-base leading-relaxed text-white/80 md:text-lg">{text}</p>
        </div>
        <div className="lg:col-span-4 lg:text-right">
          <Link to="/contact" className="inline-flex items-center gap-3 rounded-full bg-white px-7 py-4 text-sm font-semibold text-ink transition-transform duration-300 hover:-translate-y-1" data-testid="cta-band-button">
            Book a discovery call <span className="grid h-7 w-7 place-items-center rounded-full bg-flame text-white"><ArrowUpRight className="h-4 w-4" /></span>
          </Link>
        </div>
      </div>
    </div>
  </section>
);
